import TourDateRow, { type TourDateRowProps } from "./TourDateRow";

import { useVenuePageTheme } from "../../hooks";

interface TourDateRowThemedProps extends TourDateRowProps {
  venueSlug: string;
}

export default function TourDateRowThemed({
  venueSlug,
  ...rest
}: TourDateRowThemedProps) {
  const { headerBackgroundColor, buttonLabelColor, accentColor } =
    useVenuePageTheme(venueSlug);
  return (
    <TourDateRow
      {...rest}
      // Forward venueSlug so TourDateRow can render the show title as a
      // link to the venue's auto-resolved "Show Group" page.
      venueSlug={venueSlug}
      // append the specific colors for this venue's theme
      cardBackgroundColor={headerBackgroundColor}
      buttonLabelColor={buttonLabelColor}
      buttonBackgroundColor={accentColor}
    />
  );
}
